// extracted by mini-css-extract-plugin
export default {"warning_container":"max-letters-warning_warning_container__TeEgt","warning_icon":"max-letters-warning_warning_icon__jM9yu","warning_title":"max-letters-warning_warning_title__HPw2l"};